import Image from 'next/image'
import React from 'react'

import { IImage } from '@/_types'

interface IProps {
	images: IImage[]
}

export default function AAmbulanceContentImages({ images }: IProps) {
	if (!images || !images?.length) {
		return null
	}

	return (
		<div className='box_faces mgt-70lg mgt-110'>
			<div className='box_faces_sizer v2'></div>
			<div className='box_faces_items' data-timing='2000'>
				<Image
					src={images[0]?.url}
					alt='Ilustračná fotografia'
					width={1440}
					height={400}
					unoptimized={true}
				/>
			</div>

			<div className='box_faces_inner'>
				<div className='box_faces_content anim_drop1 anim_delay observe'>
					<img
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/global/v-prvom-rade-clovek.svg`}
						alt='Ilustračná fotografia'
					/>
					<img
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/global/v-prvom-rade-clovek-mobile.svg`}
						alt='Ilustračná fotografia'
					/>
				</div>
			</div>
		</div>
	)
}
